"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSkippedItems = exports.getHasPreviousPages = exports.getHasMorePages = exports.getFirstButtonIndex = exports.getCurrentPage = void 0;
const getCurrentPage = (take, skip) => {
  if (skip === undefined || take === undefined || take === 0) return 0;
  if (skip === 0) return 1;
  return Math.floor(skip / take + 1);
};
exports.getCurrentPage = getCurrentPage;
const getSkippedItems = (pageNumber, take) => {
  if (pageNumber === undefined || take === undefined) return NaN;
  return (pageNumber - 1) * take;
};
exports.getSkippedItems = getSkippedItems;
const getHasPreviousPages = (currentPage, totalPages) => {
  return currentPage > 3 && totalPages > 5;
};
exports.getHasPreviousPages = getHasPreviousPages;
const getHasMorePages = (currentPage, totalPages) => {
  return currentPage < totalPages - 2 && totalPages > 5;
};
exports.getHasMorePages = getHasMorePages;
const getFirstButtonIndex = (currentPage, totalPages) => {
  if (totalPages <= 5 || currentPage <= 3) return 0;
  if (totalPages - currentPage <= 2) return totalPages - 5;
  return currentPage - 3;
};
exports.getFirstButtonIndex = getFirstButtonIndex;